<template>
  <div class="text-center lg:text-left">
    <div class="flex flex-col gap-4 lg:flex-row lg:gap-8">
      <div class="co-display-2 flex items-start justify-center lg:min-w-[3.75rem]">
        <slot name="icon" />
      </div>
      <div>
        <h3 class="co-display-10">
          <slot name="title">
            タイトルが入ります
          </slot>
        </h3>
        <p>
          <slot name="description">
            説明が入ります
          </slot>
        </p>
      </div>
    </div>
  </div>
</template>
